import AllCategoriesNavigation from "@/app/components/elements/navigations/AllCategoriesNavigation";
import BottomHeaderItems from "./BottomHeaderItems";

const BottomHeader = () => {
  return (
    <div className="flex items-center h-12 gap-4 relative min-w-0">
      <div className="hidden md:block shrink-0">
        <AllCategoriesNavigation />
      </div>
      <div className="flex-1 min-w-0">
        <BottomHeaderItems />
      </div>
    </div>
  );
};

export default BottomHeader;